import { useEffect, useState } from "react";
import { _DodoDocs } from "../../../../../core/services/dataBean/EntityCatalog";
import { ObjectDinamicViewer } from "../ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";
import { DodoInboxDocuments } from "./InteractiveDodo/DodoInboxDocuments";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    formCode:string;
    camp:string;
    value:string;
    operator?:string;
    columns:any;
}

export const DodoDoc = ({ formCode,camp,value,operator,columns}: Props) => {

    const [radicate, setRadicate] = useState<any>({});
    const [barCode, setBarCode] = useState<string>('');
    const [head1, setHead1] = useState<any>({});
    const { instance, lista, setLista, bean, setBean } = useDataBean(_DodoDocs);

    useEffect(()=>{

        return ()=> {setBarCode('');setRadicate({})}
    },[])

    useEffect(()=>{

        if(formCode && camp && value)
        {
            instance.getFormData(formCode,camp,value,operator ?? null).then(
                (resp:any)=>{
                    console.log(resp);
                    if(resp.Data)
                    {
                        let obj = {};
                        resp.Data.forEach(element => {

                            if(element.DataBeanProperties.Key == 'Cod_Barras')
                            {
                                setBarCode(element.DataBeanProperties.Value);
                            }
                            if(columns.length>0)
                            {
                                
                                
                                if(columns.includes(element.DataBeanProperties.Key))
                                {
                                    obj[element.DataBeanProperties.Field.trim()] = element.DataBeanProperties.Value;
                                    
                                }
                            }
                            else{
                                obj[element.DataBeanProperties.Field.trim()] = element.DataBeanProperties.Value;

                            }
                        });
                        console.log(obj);

                        let h = [];
                        Object.keys(obj).forEach(k => {
                            h.push({
                                title:k,
                                property:k,
                                visible:true
                            })
                        });
                        setRadicate(obj);
                        setHead1(h);
                        console.log(h);
                        
                        
                    }
                    
                }
            )
        }else{
            toast.warning("Parametros incompletos");
        }

    },[formCode])


    const head = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: false },
        { title: 'Valor Contrato', property: 'ContractValue', visible: true },
        { title: 'Valor CDP', property: 'CDPValue', visible: false },
        { title: 'Fecha Contrato', property: 'SeleccionDate', visible: true },
        { title: 'Dodo radicado', property: 'Code', visible: false },
        { title: 'Código contrato', property: 'InternalCode', visible: true },
        { title: 'Proveedor', property: 'Name1', visible: true },
        { title: 'Descripción', property: 'Description', visible: false },
        { title: 'No CDP', property: 'NoCDP', visible: false },
        { title: 'Fecha CDP', property: 'DateCDP', visible: false },
        { title: 'No registro presupuestal', property: 'NoRegistroPresupuestal', visible: false },
        { title: 'Fecha registro presupuestal', property: 'DateRegPresupuestal', visible: false },
    ]

    return (
        <div className="row">
            
            <div className="col-md-12">
                <ObjectDinamicViewer data={radicate} head={head1} columns={3} />
            </div>
            <div className="col-md-12">
                {barCode &&
                <DodoInboxDocuments _formCode={formCode} _barCode={barCode} />
                }
            </div>
        </div>
    )
}